import TasksAccordion from './layouts/TasksAccordion'
import TasksList from './layouts/TasksList'
import SmartComponentLayout from './layouts/SmartComponentLayout'

export const LAYOUTS = {
  tasksAccordion: TasksAccordion,
  tasksList: TasksList,
  smartComponent: SmartComponentLayout
}

export const DEFAULT_LAYOUT = 'tasksAccordion'
